import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';

// home
const Home = React.lazy(() => import('../pages/Home'));


const PortfolioGrid = React.lazy(() => import('../pages/other/portfolio/PortfolioGrid'));

const PortfolioItem = React.lazy(() => import('../pages/other/portfolio/PortfolioItem'));


const loading = () => <div className=""></div>;

type LoadComponentProps = {
    component: React.LazyExoticComponent<() => JSX.Element>;
};

const LoadComponent = ({ component: Component }: LoadComponentProps) => (
    <Suspense fallback={loading()}>
        <Component />
    </Suspense>
);

const AllRoutes = () => {
    return useRoutes([

        {
            // public routes
            path: '/',
            children: [
                {
                    path: '/',
                    element: <LoadComponent component={Home} />,
                },
                { path: 'experiencias', element: <LoadComponent component={PortfolioGrid} /> },
                { path: 'documentos', element: <LoadComponent component={PortfolioItem} /> }
            ],
        }
    ]);
};

export default AllRoutes;
